<div class="clr-wrapper avi-app-level-alert">
    <clr-alerts *ngIf="messages?.length || dynamicMessages$">
        <clr-alert
            [clrAlertType]="status"
            [clrAlertAppLevel]="true"
            (clrAlertClosedChange)="closeAlert(message)"
            *ngFor="let message of messages; trackBy: trackByIndex"
        >
            <clr-alert-item>
                <div class="avi-app-level-alert__message-list">
                    <span>{{ message?.message }}</span>
                    <span
                        class="alert-actions avi-app-level-alert__action-button"
                        *ngIf="message?.actionLabel && message?.onActionClick"
                    >
                        <button
                            class="btn alert-action"
                            (click)="message.onActionClick()"
                        >
                            {{ message.actionLabel }}
                        </button>
                    </span>
                    <span
                        class="alert-actions avi-app-level-alert__action-button"
                        *ngIf="hasActionButton && !message?.onActionClick"
                    >
                        <button
                            class="btn alert-action"
                            (click)="handleAction()"
                        >
                            {{ actionLabel }}
                        </button>
                    </span>
                    <div *ngIf="message?.type === systemFaultType">
                        <span 
                            *ngIf="message?.details && message?.details?.length > 0"
                            class="alert-actions avi-app-level-alert__action-button"
                        >
                            <button
                                class="btn alert-action"
                                (click)="handleViewDetails(message?.details)"
                            >
                                {{ l10nKeys.viewDetailsLabel | vtranslate }}
                            </button>
                        </span>
                        <span class="alert-actions avi-app-level-alert__action-button">
                            <a
                                class="btn alert-action"
                                (click)="redirectToEventsPage()"
                            >
                                {{ l10nKeys.goToEventLabel | vtranslate }}
                            </a>
                        </span>
                    </div>
                </div>
            </clr-alert-item>
        </clr-alert>
    </clr-alerts>
</div>
